
export const navigateWithNewWindow = (url: string) => {
  window.open(url, '_blank');
};
